<app-drr-ccd-data-context>
  <app-consumption-device-steps *ngIf="!isDetailsView" [currentStep]="ApplicationStepType.Documents"></app-consumption-device-steps>

  <app-loader *ngIf="isLoading"></app-loader>

  <div *ngIf="!isLoading" id="print-form">
    <app-documents-submission
      *ngIf="application"
      [isDetailsView]="isDetailsView"
      [showNavSteps]="false"
      [showInquiry]="false"
      [showSubmitButton]="false"
      (onDocumentFormInit)="initDocumentForm($event)"
      [drrCcdDeviceApplicationDto]="application"></app-documents-submission>

    <div class="ui-g-12 ui-xl-12 ui-lg-12 ui-md-12 ui-sm-12 ui-xs-12 mb-30 submit-button-section">
      <button
        data-testId="btn-send-request"
        *ngIf="!isDetailsView"
        [disabled]="!documentForm?.valid"
        type="button"
        class="ui-button-proceed"
        (click)="submit()"
        label="{{ 'grid-comp.send-request' | translate | uppercase }}"
        pButton></button>
    </div>
  </div>
</app-drr-ccd-data-context>
